import withMatcher from '#/utils/withMatcher';
import { ITrackState } from '../reducers/track';

export const createActionTrackSetDetails = withMatcher(
  (payload: ITrackState) => {
    return {
      type: 'track/set_details',
      payload,
    };
  }
);

export const createActionTrackStartLoading = withMatcher(() => {
  return {
    type: 'track/start_loading',
  };
});

export const createActionTrackStopLoading = withMatcher(() => {
  return {
    type: 'track/stop_loading',
  };
});

export const createActionTrackSetError = withMatcher((error: boolean) => {
  return {
    type: 'track/set_error',
    payload: error,
  };
});

export const createActionTrackSetFavorite = withMatcher(
  (payload: { favorite: boolean }) => {
    return {
      type: 'track/set_track_favorite',
      payload,
    };
  }
);

export const createActionTrackSetTopTrackFavorite = withMatcher(
  (payload: { track: string; favorite: boolean }) => {
    return {
      type: 'track/set_top_track_is_favorite',
      payload,
    };
  }
);

export const createActionTrackSetAlbumTrackFavorite = withMatcher(
  (payload: { track: string; favorite: boolean }) => {
    return {
      type: 'track/set_album_track_is_favorite',
      payload,
    };
  }
);

export const createActionTrackReset = withMatcher(() => {
  return {
    type: 'track/reset',
  };
});
